import { observer } from 'mobx-react-lite';
import React from 'react';
import { DraggableCore } from 'react-draggable';
import styled from 'styled-components';

import { useTranscriptLayoutResize } from '../../hooks/useTranscriptLayoutResize';
import { useLayoutStore } from '../../stores-v2';
import { ResizeBorderVertical } from '../common/ResizeBorder';
import { Transcript } from '../transcript/Transcript';

export const LeftSidePanel: React.FC<{}> = observer(() => {
  const {
    isDragging,
    throttledHandleMouseMove,
    handleMouseDown,
    handleMouseUp,
  } = useTranscriptLayoutResize();

  const layoutStore = useLayoutStore();
  const { transcriptWidth, transcriptMinWidth, transcriptMaxWidth } =
    layoutStore;

  return (
    <Panel
      currentWidth={transcriptWidth}
      maxWidth={transcriptMaxWidth}
      minWidth={transcriptMinWidth}
    >
      <Transcript />
      <DraggableCore
        onDrag={e => {
          throttledHandleMouseMove(e as unknown as MouseEvent);
        }}
        onStop={handleMouseUp}
        onMouseDown={handleMouseDown}
      >
        <ResizeBorderVertical
          onMouseUp={handleMouseUp}
          isDragging={isDragging}
          position="right"
        />
      </DraggableCore>
    </Panel>
  );
});

const Panel = styled.div<{
  currentWidth: string;
  minWidth: number;
  maxWidth: number;
}>`
  position: relative;
  padding: 0px 5px 5px;
  width: ${props => props.currentWidth || '380px'};
  min-width: ${props => props.minWidth || '190px'};
  max-width: ${props => props.maxWidth || '760px'};
  display: flex;
  border-right: 1px solid #404040;
`;
